import { api } from "api/common";
import {
  GET_METHODOLOGY_PDF,
  HOME_URL
} from "api/constants";
import { setToastMessage } from "components/app/actions";
import { createActionsHook } from "react-redux-actions-hook";


export const getMethodologyPDF = (setDisabledDownload) => {
  return (dispatch) => {
    setDisabledDownload(true)
    api(
      `${HOME_URL}${GET_METHODOLOGY_PDF}`,
      { method: "GET" },
      dispatch
    )
      .then((res) => {
        res.blob().then(blob => {
          let url = window.URL.createObjectURL(blob);
          let downloadElement = document.createElement('a');
          downloadElement.href = url;
          downloadElement.download = 'CuRVE Methodology Package 2024.pdf';
          downloadElement.click();
          setDisabledDownload(false)
          dispatch(
            setToastMessage({
              message: "Downloaded PDF",
              type: "success",
            })
          );
        });
      })
      .catch((error) => {
        setDisabledDownload(false)
        //Handle Error
        dispatch(
          setToastMessage({
            message: error.message || "Something went wrong, please try again in a while",
            type: "error",
          })
        );
      });
  };
};


export default createActionsHook({
  getMethodologyPDF
});
